<template>
  <b-container fluid>
    <b-row class="h-100">
      <b-col class="mainColumn" cols="3">
        <b-row class="tableRow">
          <SelectionTable/>
        </b-row>
      </b-col>

      <b-col v-if="$store.getters.selectionSelect.name" class="mainColumn" cols="9">
        <div>
          <SelectionForm/>
        </div>
        <div class="cTable">
          <Cards/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'
import SelectionForm from '@/components/selectionForm.vue'
import SelectionTable from '@/components/selectionTable.vue'
import Cards from '@/components/cards.vue'

export default Vue.extend({
  name: 'peopleDetail',
  data () {
    return {
      cardBtnDetail: true,
      cardBtnAddToSelection: false,
      cardBtnRemoveFromSelection: true,
      cardBtnConfirmed: true,
      selectionNotesTab: true,
      cardImgWidth: 15,
      cardImgHeight: 25
    }
  },
  components: {
    SelectionForm,
    SelectionTable,
    Cards
  },
  methods: {
  },
  mounted () {
    this.$store.commit('cards', [])
    this.$store.commit('selectionSelect', {})
    this.$store.commit('selectionShowClosed', false)
  },
  beforeDestroy () {
    this.$store.commit('selection', [])
    this.$store.commit('selectionSelect', {})
  }

})
</script>

<style>
.mainColumn {
  display: flex;
  flex-direction: column;
}

.tableRow {
  display: flex;
  flex: 1;
}

.cTable {
  display: flex;
  flex: 1;
  overflow: auto;
  flex-grow: 1;
  flex-basis: 0;
}
</style>
